import React from 'react';
export var WindowManagerStateContext = React.createContext({
    designMode: false,
});
